module.exports = __webpack_public_path__ + "img/hr-train-wheels-7.b08e3266.png";